import { useQuery } from '@apollo/client';
import React, { useContext } from 'react';
import Dialog from '../../../../../../../BaseComponents/Dialog/EDDialog';
import EDDivider from '../../../../../../../BaseComponents/Divider/EDDivider';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import { findFormatter } from '../../../../../../../Utils/Formatters/FindFormatter';
import getBokfkonteringForModalQuery from './Queries/GetBokfkonteringForModal.gql';
import { ActiveDatabaseContext } from '../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import {
  GetBokfkonteringForModal,
  GetBokfkonteringForModalVariables,
} from './Queries/_QueryTypes/GetBokfkonteringForModal';
import EDBox from '../../../../../../../BaseComponents/EDBox/EDBox';

interface IProps {
  open: boolean;
  onClose: () => void;
  vernr: string;
  bokfYear: string;
  noDataText: string;
}

const BokfKonteringModal: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { activeDatabase } = useContext(ActiveDatabaseContext);

  const { data } = useQuery<
    GetBokfkonteringForModal,
    GetBokfkonteringForModalVariables
  >(getBokfkonteringForModalQuery, {
    variables: {
      dbName: activeDatabase ?? '',
      vernr: props.vernr ?? '',
      bokfYear: props.bokfYear,
    },
    skip: !props.vernr,
  });

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      title={'Bokförda konteringar'}
      footerActions={[
        {
          label: 'Stäng',
          onClick: props.onClose,
        },
      ]}
    >
      {data?.db?.EKBokfkontering_All?.length === 0 ? (
        <EDTypography>{props.noDataText}</EDTypography>
      ) : (
        data?.db?.EKBokfkontering_All?.map((kontering, index) => {
          return (
            <EDBox component={'span'} key={index}>
              <EDTypography>
                <EDTypography>
                  {'Belopp: '}
                  <EDTypography bold component="span">
                    {findFormatter('TEDFormatCurr').displayer.display(
                      kontering?.Saldo,
                      true
                    )}
                  </EDTypography>
                </EDTypography>
                <EDTypography>
                  {'Konto: '}
                  <EDTypography bold component="span">
                    {kontering.PERIODISERAD
                      ? kontering.PeriodiseradTillKontostrang
                      : kontering?.Kontostrang}
                  </EDTypography>
                </EDTypography>
                <EDTypography>
                  {'Benämning: '}
                  <EDTypography bold component="span">
                    {kontering.PERIODISERAD
                      ? kontering.PeriodiseradTillKontoben
                      : kontering?.Kontoben}
                  </EDTypography>
                </EDTypography>
              </EDTypography>
              <EDDivider
                marginY={
                  index === (data?.db?.EKBokfkontering_All?.length ?? 1) - 1
                    ? undefined
                    : 1
                }
                marginTop={
                  index === (data?.db?.EKBokfkontering_All?.length ?? 1) - 1
                    ? 1
                    : undefined
                }
              />
            </EDBox>
          );
        })
      )}
    </Dialog>
  );
};

export default BokfKonteringModal;
